import { Outlet } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import { AuthGuard } from '@/components/auth/guards/auth-guard';
import { SetupGuard } from '@/components/auth/guards/setup-guard';
import { MinimalLayout } from '@/layouts/v2/minimal-layout';

export const route: RouteObject = {
  path: 'setup',
  element: (
    <AuthGuard>
      <SetupGuard inverse>
        <MinimalLayout>
          <Outlet />
        </MinimalLayout>
      </SetupGuard>
    </AuthGuard>
  ),
  children: [
    {
      path: 'community',
      lazy: async () => {
        const { CommunitySetupPage } = await import('@/pages/v2/setup/index');
        return { Component: CommunitySetupPage };
      },
    },

    {
      path: 'account',
      lazy: async () => {
        const { AccountSetupPage } = await import('@/pages/v2/setup/account/index');
        return { Component: AccountSetupPage };
      },
    },
    {
      path: 'welcome',
      lazy: async () => {
        const { WelcomePage } = await import('@/pages/v2/setup/welcome/index');
        return { Component: WelcomePage };
      },
    },
  ],
};
